
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getOverdue } from "@/api/proforma";
import { getOrderOverdue } from "@/api/purchase-order";

@Component({
  name: "ModifyDiscounts",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: true }) private isSales: boolean;
  @Prop({ default: "查看明细" }) private title: "";
  @Prop({ default: {} }) private selectedItem: {} | any;

  @Watch("show", { immediate: true })
  private watchShow() {
    if (this.show && this.selectedItem.id) {
      this.getList();
    }
  }

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "询价参照号",
      prop: "inquiryRefNumber",
      key: "inquiryRefNumber",
      show: true,
    },
    {
      label: "号码类型",
      prop: "inquiryRefType",
      key: "inquiryRefType",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单号",
      prop: "purchaseOrderCode",
      key: "purchaseOrderCode",
      show: true,
      disabled: false,
    },
    {
      label: "供应商简称",
      prop: "supplierName",
      key: "supplierName",
      show: true,
      disabled: false,
    },
    {
      label: "原始接单数量",
      prop: "originalShippingQuantity",
      key: "originalShippingQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "原始下单数量",
      prop: "originalOrderQuantity",
      key: "originalOrderQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "超欠发数量",
      prop: "overUnderQuantity",
      key: "overUnderQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "状态",
      prop: "status",
      key: "status",
      show: true,
      disabled: false,
    },
  ] as any;

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const res: any = this.isSales
      ? await getOverdue(this.selectedItem.id)
      : await getOrderOverdue(this.selectedItem.id);
    // this.table.total = +total;
    this.table.list = res;
    this.loading = false;
  }
}
